var readSet = 0;
var writeSet = 0;
var deleteSet = 0;
var baseURL = "";
var adminUrl = "";
var sno = 0;
var currentRoute = "";

// var todayDate = new Date();
// todayDate.setDate(todayDate.getDate() + 7);
// var seventhDayFormated = todayDate.toISOString().substr(0,10);
// var todayDateFormatted = new Date().toISOString().slice(0, 10);

var fromDate = $("#filter_date_from").val();
var toDate = $("#filter_date_to").val();
var state = $("#filter_state").val();
var city = $("#filter_city").val();

var filterSearchArray = [
  "sort",
  "order",
  "filter_status",
  "filter_date_from",
  "filter_date_to",
  "filter_category",
  "filter_name",
  "filter_mobile",
  "filter_email",
  "filter_product",
  "filter_devotee_name",
  "filter_devotee_email",
  "filter_devotee_mobile",
  "filter_service_name",
  "filter_category_id",
  "filter_irumudi_date_from",
  "filter_irumudi_date_to",
  "filter_devotee_id",
  "filter_id",
  "filter_steps_date_to",
  "filter_steps_date_from",
  "filter_state",
  "filter_city",
  "filter_amount",
  "filter_event_category_id",
  "filter_event_name",
  "filter_customer_id",
  "filter_dining_cost",
  "filter_dining_count",
  "filter_take_away_cost",
  "filter_take_away_count",
  "filter_total_amount_paid",
  "filter_event_date",
  "filter_dining_cost",
  "filter_take_away_cost",
  "filter_dining_count",
  "filter_take_away_count",
  "filter_total_amount_paid",
  "filter_created_date",
  "filter_activities",
  "filter_timings",
  "filter_dining_timeslots",
  "filter_take_away_timeslots",
  "filter_activities_status",
  "filter_product_id",
  "filter_going_type",
];

var daysEnabledByWeek = [];
var allowedDays = [];
var restrictedDays = [];
var irumudiDaysEnabledByWeek = [];
var irumudiAllowedDays = [];
var irumudiRestrictedDays = [];
var onamSadyaDineInTimeSlots = [];
var onamSadyaTakeAwayTimeSlots = [];
var volunteerActivities = [];
var volunteerTiming = [];
var dineSno = 0;
var takeSno = 0;
var onamSadyaSlotObj = {};
var selectedActivities = [];
var selectedTimings = [];
var activityTimings = {};
var contestActivities = [];
var contestTiming = [];

// Check if jQuery is loaded
if (typeof jQuery === 'undefined') {
  console.error("jQuery is not loaded!");
} else {
  console.log("jQuery version:", jQuery.fn.jquery);
}

$(document).ready(function() {
  console.log("Document ready function is executing...");
  
  baseURL = funGetValueWe("txtBaseUrl");
  adminUrl = funGetValueWe("txtAdminUrl");
  currentRoute = funGetValueWe("txtCurrentRoute");

  console.log("Current route:", currentRoute);
  console.log("Base URL:", baseURL);
  console.log("Admin URL:", adminUrl);

  // Initialize chosen.js if available
  try {
    if (typeof $.fn.chosen !== 'undefined') {
      $(".choosen")
        .chosen({
          disable_search_threshold: 10,
          width: "100%",
          disable_search: false,
          display_selected_options: true,
          disable_search_threshold: 0,
        })
        .change(function(event) {
          if (event.target == this) {
            funSetValue("filter_product", $(this).val());
          }
        });
      console.log("Chosen.js initialized successfully");
    } else {
      console.warn("Chosen.js library is not loaded");
    }
  } catch (error) {
    console.error("Error initializing Chosen.js:", error);
  }

  if (currentRoute === "tadmin/reports") {
    var serviceId = funGetValueWe("filter_product");
    if (serviceId) {
      console.log(serviceId);
      $.ajax({
        // Ajax call
        type: "GET",
        dataType: "JSON",
        url: baseURL + adminUrl + "/ajax/service-name/" + serviceId,
        success: function(response) {
          console.log(response);
          funSetValue("filter_product_name", response.name);
        },
        error: function() {
          funErrorMessage("Error occured !!! Please try after sometime.");
        },
      });
    }
  }

  // Initialize datepickers on page load
  initializeDatepickers();

  // var dineInData = funGetValueWe('txtDineInTimeSlotList');
  // var takeAwayData = funGetValueWe('txtTakeAwaySlotList');

  // if (dineInData) {
  //   dineInData = JSON.parse(dineInData);
  //   onamSadyaDineInTimeSlots = dineInData;
  //   onamSadyaSlotObj.dineInSlot = dineInData;
  // }

  // if (takeAwayData) {
  //   takeAwayData = JSON.parse(takeAwayData);
  //   onamSadyaTakeAwayTimeSlots = takeAwayData;
  //   onamSadyaSlotObj.takeAwaySlot = takeAwayData;
  // }

  if (currentRoute === "tadmin/mandalam/dashboard") {
    onFilterMandalamDashboard();
    console.log("Trigger filter");
  }

  if (currentRoute === "tadmin/onam-sadya/events") {
    var timeSlots = funGetValueWe("txtTimeSlotData");
    if (timeSlots) {
      timeSlots = JSON.parse(timeSlots);
      onamSadyaDineInTimeSlots = timeSlots.dineInSlots || [];
      onamSadyaTakeAwayTimeSlots = timeSlots.takeAwaySlots || [];
      reRenderDineInSlots();
      reRenderTakeAwaySlots();
    }
  }

  if (currentRoute === "tadmin/volunteer/events") {
    var activities = funGetValueWe("txtActivitiesData");
    var activityTimingsLocal = funGetValueWe("txtActivityTiming");
    activityTimingsLocal = activityTimingsLocal
      ? JSON.parse(activityTimingsLocal)
      : {};
    if (activities) {
      console.log({ activities });
      activities = JSON.parse(activities);
      volunteerActivities = activities.activities || [];

      for (var i = 0; i < volunteerActivities.length; i++) {
        activityTimings[
          volunteerActivities[i].activities
        ] = activityTimingsLocal[volunteerActivities[i].activities]
          ? activityTimingsLocal[volunteerActivities[i].activities]
          : [];
      }

      reRenderVolunteerActivities();
      renderTimeSchedulingContent();
    }

    if (activityTimingsLocal) {
      // activityTimings = JSON.parse(activityTimingsLocal);
      for (var i = 0; i < volunteerActivities.length; i++) {
        funReRenderActivityTimings(i);
      }
    }
  }

  if (currentRoute === "tadmin/volunteer/events") {
    var slot = funGetValueWe("txtSlotData");
    if (slot) {
      console.log({ slot });
      slot = JSON.parse(slot);
      volunteerTiming = slot.slot || [];
      reRenderVolunteerTiming();
    }
  }

  if (currentRoute === "tadmin/contest/events") {
    var activities = funGetValueWe("txtActivitiesData");
    var activityTimingsLocal = funGetValueWe("txtActivityTiming");
    activityTimingsLocal = activityTimingsLocal
      ? JSON.parse(activityTimingsLocal)
      : {};
    if (activities) {
      console.log({ activities });
      activities = JSON.parse(activities);
      contestActivities = activities.activities || [];

      for (var i = 0; i < contestActivities.length; i++) {
        activityTimings[contestActivities[i].activities] = activityTimingsLocal[
          contestActivities[i].activities
        ]
          ? activityTimingsLocal[contestActivities[i].activities]
          : [];
      }

      reRenderContestActivities();
      renderContestTimeSchedulingContent();
    }

    if (activityTimingsLocal) {
      // activityTimings = JSON.parse(activityTimingsLocal);
      for (var i = 0; i < contestActivities.length; i++) {
        funReRenderContestActivityTimings(i);
      }
    }
  }

  if (currentRoute === "tadmin/contest/events") {
    var slot = funGetValueWe("txtSlotData");
    if (slot) {
      console.log({ slot });
      slot = JSON.parse(slot);
      contestTiming = slot.slot || [];
      reRenderContestTiming();
    }
  }

  if (currentRoute == "tadmin/onam-sadya/reports/edit/{id}") {
    var dineInSlots = funGetValueWe("txtDiningSlots");
    var takeAwaySlots = funGetValueWe("txtTakeAwaySlots");

    console.log({ dineInSlots, takeAwaySlots });

    if (dineInSlots) {
      var formattedDineSlots = JSON.parse(dineInSlots);
      console.log({ formattedDineSlots });
      onamSadyaDineInTimeSlots = formattedDineSlots;
      funRenderOnamSadyaDineInReport(formattedDineSlots);
    }

    if (takeAwaySlots) {
      var formattedTakeAwaySlots = JSON.parse(takeAwaySlots);
      onamSadyaTakeAwayTimeSlots = formattedTakeAwaySlots;
      funRenderOnamSadyaTakeAwayReport(formattedTakeAwaySlots);
    }
  }

  if (currentRoute === "tadmin/volunteer/reports") {
    var status = funGetValueWe("txtSelectedFilterActivityStatus");
    var activities = funGetValueWe("txtSelectedFilterActivity");
    var timings = funGetValueWe("txtSelectedFilterTiming");
    console.log(activities, timings);
    if (status) {
      funActivityChanges(status, activities);
    }
    if (activities) {
      funTimingChanges(activities, timings);
      console.log(activities);
    }
  }

  if (currentRoute == "tadmin/volunteer/reports/edit/{id}") {
    var activities = funGetValueWe("txtActivitiesSelected");
    var timings = funGetValueWe("txttimingsSelected");

    var activitiesArray = activities ? activities.split(",") : [];
    var timingsArray = timings ? timings.split(",") : [];

    selectedActivities = activitiesArray;
    selectedTimings = timingsArray;
  }

  if (currentRoute === "tadmin/contest/reports") {
    var activities = funGetValueWe("filter_activities");
    var timings = funGetValueWe("txtSelectedFilterTiming");
    console.log(timings);
    if (activities) {
      funContestTimingChanges(activities, timings);
      console.log(activities);
    }
  }

  if (currentRoute == "tadmin/contest/reports/edit/{id}") {
    var activities = funGetValueWe("txtActivitiesSelected");
    var timings = funGetValueWe("txttimingsSelected");

    var activitiesArray = activities ? activities.split(",") : [];
    var timingsArray = timings ? timings.split(",") : [];

    selectedActivities = activitiesArray;
    selectedTimings = timingsArray;
  }

  if (currentRoute === "tadmin/mandalam/events/edit/{id}") {
    var metadata = funGetValueWe("txtMetaData");
    console.log({ metadata });
    var membertypescheduling = funGetValueWe("txtMemberTypeScheduling");
    if (membertypescheduling) {
      membertypescheduling = JSON.parse(
        funGetValueWe("txtMemberTypeScheduling")
      );
      console.log({ membertypescheduling });
      funSetValue("txtMandalamSchedulingType", "enabled");
      if (txtMandalamSchedulingType.value == "enabled")
        $("#divMemberTypeScheduling").removeClass("hidden");
      console.log({ adult: membertypescheduling.adult });
      funSetValue("adult_no_of_days", membertypescheduling.adult);
      funSetValue("kid_no_of_days", membertypescheduling.kid);
      funSetValue(
        "senior_citizen_no_of_days",
        membertypescheduling.senior_citizen
      );
    }
    if (metadata) {
      metadata = JSON.parse(funGetValueWe("txtMetaData"));
      console.log({ metadata });
      var formType = funGetValueWe("form_type");

      if (
        formType == "2" ||
        formType == "1" ||
        formType == "5" ||
        formType == "6"
      ) {
        if (metadata.enabled_days_by_week) {
          daysEnabledByWeek = metadata.enabled_days_by_week.split(",");
          console.log({ daysEnabledByWeek });
          for (var i = 0; i < daysEnabledByWeek.length; i++) {
            $("#day_" + daysEnabledByWeek[i]).prop("checked", true);
          }
        }

        if (metadata.available_dates)
          allowedDays = metadata.available_dates.split(",");

        if (metadata.restricted_dates)
          restrictedDays = metadata.restricted_dates.split(",");

        funSetValue("mandalam_min_date", metadata.mandalam_min_date);
        funSetValue("mandalam_max_date", metadata.mandalam_max_date);
      }

      if (formType == "1" || formType == "3") {
        if (metadata.irumudi_enabled_days_by_week) {
          irumudiDaysEnabledByWeek = metadata.irumudi_enabled_days_by_week.split(
            ","
          );
          for (var i = 0; i < irumudiDaysEnabledByWeek.length; i++) {
            $("#irumudi_day_" + irumudiDaysEnabledByWeek[i]).prop(
              "checked",
              true
            );
          }
        }

        if (metadata.irumudi_available_dates)
          irumudiAllowedDays = metadata.irumudi_available_dates.split(",");

        if (metadata.irumudi_restricted_dates)
          irumudiRestrictedDays = metadata.irumudi_restricted_dates.split(",");

        funSetValue("irumudi_min_date", metadata.irumudi_min_date);
        funSetValue("irumudi_max_date", metadata.irumudi_max_date);
      }

      renderWeekDays();
      renderAvailableDates();
      renderRestrictedDates();

      renderIrumudiWeekDays();
      renderIrumudiAvailableDates();
      renderIrumudiRestrictedDates();
    }
  }

  $("#formResetPassword").submit(function(event) {
    var password = funGetValueWe("txt_new_password");
    var confirm = funGetValueWe("txt_confirm_password");
    if (password != confirm) {
      fun_error_message("password and confirm does mot match");
    } else {
      $.ajax({
        // Ajax call
        type: "POST",
        dataType: "JSON",
        url: baseURL + adminUrl + "/ajax/reset-password",
        data: "_token=" + funGetToken() + "&password=" + password,
        success: function(response) {
          if (response.status == true) {
            // $("#span_log_count").css("display","none");
            funSetValue("txt_new_password", "");
            funSetValue("txt_confirm_password", "");
            funCloseModal("modalResetPassword");
            funSuccessMessage(response.message);
          } else {
            funErrorMessage(response.message);
          }
        },
        error: function() {
          funHideLoader();
          funErrorMessage("Error occured !!! Please try after sometime.");
        },
      });
    }
    event.preventDefault();
  });

  var txtSno = funGetValue("txtSno");
  if (txtSno) {
    sno = txtSno;
    console.log(sno);
  }

  var txtDineSno = funGetValue("txtDineSno");
  if (txtDineSno) {
    dineSno = txtDineSno;
    console.log(dineSno);
  }
  var txtTakeSno = funGetValue("txtTakeSno");
  if (txtTakeSno) {
    takeSno = txtTakeSno;
    console.log(takeSno);
  }
});

function fun_check_all(type) {
  if (type == "read" && readSet == 0) {
    $(".checkRead").prop("checked", true);
    readSet = 1;
  } else if (type == "read" && readSet == 1) {
    $(".checkRead").prop("checked", false);
    readSet = 0;
  }

  if (type == "write" && writeSet == 0) {
    $(".checkWrite").prop("checked", true);
    writeSet = 1;
  } else if (type == "write" && writeSet == 1) {
    $(".checkWrite").prop("checked", false);
    writeSet = 0;
  }

  if (type == "delete" && deleteSet == 0) {
    $(".checkDelete").prop("checked", true);
    deleteSet = 1;
  } else if (type == "delete" && deleteSet == 1) {
    $(".checkDelete").prop("checked", false);
    deleteSet = 0;
  }
}

function funLogout() {
  funOpenModal("modalSystemLogout");
}

function funOpenModal(id, arg) {
  if (arg == true) {
    $("#" + id).modal({ backdrop: "static", keyboard: false });
  }

  $("#" + id).modal("show");
}

function funCloseModal(id) {
  $("#" + id).modal("hide");
}

function funLogoutConfirm() {
  var base_url = funGetValueWe("txtBaseUrl");
  window.location = base_url + adminUrl + "/logout";
}

function funGetValueWe(id) {
  return $.trim($("#" + id).val());
}

function funGetToken() {
  return $("input[name=_token]").val();
}

function funShowLoader() {
  $("body")
    .addClass("loading")
    .addClass("overlay")
    .loader("show", {
      loader: false,
      overlay: true,
    });
  return true;
}

function funHideLoader() {
  $("body")
    .removeClass("loading")
    .loader("hide");
  return true;
}

function funSuccessMessage(msg) {
  toastr.clear();
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-bottom-center",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };
  toastr.success(msg);
  return true;
}

function funErrorMessage(msg) {
  toastr.clear();
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-bottom-center",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };
  toastr.error(msg);
  return true;
}

function funSetAdminLeftBar() {
  var token = $("input[name='_token']").val();
  $.ajax({
    // Ajax call
    type: "GET",
    url: baseURL + adminUrl + "/ajax/set-admin-left-menu",
    data: "_token=" + token,
    success: function(response) {},
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    },
  });
}

function funSetValue(id, value) {
  $("#" + id).val(value);
}

function funGetValue(id) {
  return encodeURIComponent($.trim($("#" + id).val()));
}

function funFilterSearchSubmit() {
  var redirect = funGetValueWe("redirect");
  var query_url = "";

  $(filterSearchArray).each(function(index, value) {
    console.log(value + " - " + funGetValue(value));

    if (funGetValue(value) != "") {
      console.log("coming in");
      // console.log(funGetValue(value));
      query_url = funSetQueryUrlValue(query_url, value, funGetValue(value));
    }

    if (funGetValue(value) == "") {
      console.log("coming in 2");
      query_url = funRemoveUrlValue(
        query_url,
        value,
        funGetUrlParameter(value)
      );
    }

    // console.log(query_url);
  });

  if (query_url == "") url = funGetValueWe("page_url");
  else url = funGetValueWe("page_url") + "?" + query_url;
  url = funUrlValidator(url);
  url = funUrlValidator(url);
  console.log("redirect url - " + url);
  window.location = url;
}

function funSetQueryUrlValue(query_url, parameter_name, parameter_value) {
  // console.log('parameter Value - '+parameter_value);
  if (query_url == "") query_url = parameter_name + "=" + parameter_value;
  else query_url = query_url + "&" + parameter_name + "=" + parameter_value;
  return query_url;
}

function funUrlValidator(url) {
  url = url.replace("?&", "?");
  url = url.replace("&&", "&");
  url = url.replace("&&&", "&");
  return url.replace(/&&+$/, "");
}

function funRemoveUrlValue(query_url, name, value) {
  para_value = name + "=" + value;
  query_url = query_url.replace(para_value, "");
  query_url = query_url.replace(/&+$/, "");
  return query_url.replace(/&&+$/, "");
}

function funGetUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
}

function addSubProducts() {
  var serviceName = funGetValueWe("txtServiceName");
  var eventDate = funGetValueWe("txtServiceDate");
  var amount = funGetValueWe("txtServiceAmount");
  var sortOrder = funGetValueWe("txtSortOrder");
  console.log(serviceName, eventDate, amount, sortOrder);

  var template =
    '<div id="addProductRows' +
    sno +
    '" class="form-row col-md-12"><div class="col-md-2 mr10"><div class="form-group"><input type="text" name="productEntries[' +
    sno +
    '][service_name]" class="form-control" placeholder="Name" value="' +
    serviceName +
    '" /></div></div>';
  template +=
    '<div class="col-md-2 mr10"><div class="form-group"><input type="text" name="productEntries[' +
    sno +
    '][event_date]" class="form-control date" placeholder="Name" value="' +
    eventDate +
    '" /></div></div>';
  template +=
    '<div class="col-md-2 mr10"><div class="form-group"><input type="text" name="productEntries[' +
    sno +
    '][amount]" class="form-control" placeholder="Name" value="' +
    amount +
    '" /></div></div>';
  template +=
    '<div class="col-md-2 mr10"><div class="form-group"><input type="text" name="productEntries[' +
    sno +
    '][sort_order]" class="form-control" placeholder="Name" value="' +
    sortOrder +
    '" /></div></div>';
  template +=
    '<div class="col-md-2 mr10"><button class="btn btn-danger btn-sm" onclick="removeProductEntries(' +
    sno +
    ')">X</button></div></div>';
  $("#productEntries").append(template);
  // Initialize datepickers for newly added elements
  initializeDatepickers();
  clearProductEntry();
  sno++;
}

function clearProductEntry() {
  funSetValue("txtServiceName", "");
  funSetValue("txtServiceDate", "");
  funSetValue("txtServiceAmount", "");
  funSetValue("txtSortOrder", "");
}

function removeProductEntries(sno) {
  $("#addProductRows" + sno).remove();
}

function changeCategoryStatus(id) {
  var token = $("input[name='_token']").val();
  $.ajax({
    // Ajax call
    type: "POST",
    url: baseURL + adminUrl + "/ajax/set-category-status",
    data: "_token=" + token + "&id=" + id,
    success: function(response) {
      console.log(response);
      $("#spanStatus" + id).html(response.message);
    },
    error: function(err) {
      console.log(err);
      console.log("Error occured !!! Please try after sometime.");
      location.reload();
    },
  });
}

function changeProductStatus(id) {
  var token = $("input[name='_token']").val();
  $.ajax({
    // Ajax call
    type: "POST",
    url: baseURL + adminUrl + "/ajax/set-product-status",
    data: "_token=" + token + "&id=" + id,
    success: function(response) {
      console.log(response);
      $("#spanStatus" + id).html(response.message);
    },
    error: function(err) {
      console.log(err);
      console.log("Error occured !!! Please try after sometime.");
      location.reload();
    },
  });
}

function fun_filter_search_submit() {
  var redirect = funGetValueWe("redirect");
  var query_url = "";

  $(filterSearchArray).each(function(index, value) {
    console.log(value + "-" + funGetValue(value));

    if (funGetValue(value) != "") {
      console.log("coming in");
      // console.log(funGetValue(value));
      query_url = funSetQueryUrlValue(query_url, value, funGetValue(value));
    }

    if (funGetValue(value) == "") {
      console.log("coming in 2");
      query_url = funRemoveUrlValue(
        query_url,
        value,
        funGetUrlParameter(value)
      );
    }
    // console.log(query_url);
  });

  if (query_url == "") url = funGetValueWe("page_url");
  else url = funGetValueWe("page_url") + "?" + query_url;
  url = funUrlValidator(url);
  url = funUrlValidator(url);
  console.log("redirect url - " + url);
  window.location = url;
}

function changeMandalamEventStatus(id) {
  var token = $("input[name='_token']").val();
  $.ajax({
    // Ajax call
    type: "POST",
    url: baseURL + adminUrl + "/ajax/set-mandalam-event-status",
    data: "_token=" + token + "&id=" + id,
    success: function(response) {
      console.log(response);
      $("#spanStatus" + id).html(response.message);
    },
    error: function(err) {
      console.log(err);
      console.log("Error occured !!! Please try after sometime.");
      location.reload();
    },
  });
}

function funFocusGoto(id) {
  console.log(id);
  $("#" + id).focus();
  $("#" + id).select();
}

// Function to initialize datepickers for elements with .date class
function initializeDatepickers() {
  $(".date").datepicker({
    autoHide: true,
    format: "mm/dd/yyyy",
    todayHighlight: true,
  });
}

function funAddDates() {
  var nachathiram_dates = funGetValueWe("txtDates");
  var id = funGetValueWe("txtDatesid");

  if (nachathiram_dates) {
    var __template = "";
    __template += "<tr id='entry" + sno + "'> ";
    __template += "<td> " + nachathiram_dates + "</td> ";
    __template +=
      "<td> <button type='button' class='btn btn-danger btn-sm' onclick='funRemoveDates(" +
      sno +
      ")'> <i class='fa fa-trash'> </i>  </button> </td> ";
    __template +=
      "<input type='hidden' name='dates[" +
      sno +
      "]' value='" +
      nachathiram_dates +
      "' /> ";
    __template += "</tr> ";

    funSetValue("txtDates", "");
    funFocusGoto("txtDatesid");
    $("#tbodyDates").append(__template);
    sno++;
  } else funErrorMessage("Enter the date");
}

function funRemoveDates(id) {
  console.log(id);
  $("#entry" + id).remove();
}

function funMandalaSeasonRemoveItem(id) {
  $(".trItem" + id).remove();
}

function funAddMandalamReport() {
  var formType = funGetValueWe("txtFormType");
  var template = "";
  if (formType == 1) {
    template += '<tr class="trItem' + sno + '">';
    template +=
      '<td> <input class="form-control" type="text" name="detail[' +
      sno +
      '][full_name]" value=""> </td> ';
    template += "<td>";
    template +=
      ' <select class="form-control" name="detail[' +
      sno +
      '][adult_or_kid]"> ';
    template += '<option value="1"> Adult </option> ';
    template += '<option value="2"> kid </option>  ';
    template += "</select> </td>";
    template +=
      '<td> <input class="form-control date" type="text" name="detail[' +
      sno +
      '][maladharnam_date]" value="" /> </td> ';
    template +=
      '<td> <input class="form-control date" type="text" name="detail[' +
      sno +
      '][irumudi_date]" value="" /> </td> ';
    template +=
      '<td> <button type="button" onclick="funMandalaSeasonRemoveItem(' +
      sno +
      ')" class="btn btn-danger"> <i class="fa fa-trash"> </i></button> </td> ';
    template += " </tr>";
    $("#tbodyReportEdit").append(template);
    // Initialize datepickers for newly added elements
    initializeDatepickers();
    sno++;
  }
  if (formType == 2) {
    template += '<tr class="trItem' + sno + '">';
    template +=
      '<td> <input class="form-control" type="text" name="detail[' +
      sno +
      '][full_name]" value=""> </td> ';
    template += "<td>";
    template +=
      ' <select class="form-control" name="detail[' +
      sno +
      '][adult_or_kid]"> ';
    template += '<option value="1"> Adult </option> ';
    template += '<option value="2"> kid </option>  ';
    template += "</select> </td>";
    template +=
      '<td> <input class="form-control date" type="text" name="detail[' +
      sno +
      '][maladharnam_date]" value="" /> </td> ';
    template +=
      '<td> <button type="button" onclick="funMandalaSeasonRemoveItem(' +
      sno +
      ')" class="btn btn-danger"> <i class="fa fa-trash"> </i></button> </td> ';
    template += " </tr>";
    $("#tbodyReportEdit").append(template);
    // Initialize datepickers for newly added elements
    initializeDatepickers();
    sno++;
  }
  if (formType == 3) {
    template += '<tr class="trItem' + sno + '">';
    template +=
      '<td> <input class="form-control" type="text" name="detail[' +
      sno +
      '][full_name]" value=""> </td> ';
    template += "<td>";
    template +=
      ' <select class="form-control" name="detail[' +
      sno +
      '][adult_or_kid]"> ';
    template += '<option value="1"> Adult </option> ';
    template += '<option value="2"> kid </option>  ';
    template += "</select> </td>";
    template +=
      '<td> <input class="form-control date" type="text" name="detail[' +
      sno +
      '][irumudi_date]" value="" /> </td> ';
    template +=
      '<td> <button type="button" onclick="funMandalaSeasonRemoveItem(' +
      sno +
      ')" class="btn btn-danger"> <i class="fa fa-trash"> </i></button> </td> ';
    template += " </tr>";
    $("#tbodyReportEdit").append(template);
    // Initialize datepickers for newly added elements
    initializeDatepickers();
    sno++;
  }

  if (formType == 4) {
    template += '<tr class="trItem' + sno + '">';
    template +=
      '<td> <input class="form-control" type="text" name="detail[' +
      sno +
      '][name]" value=""> </td> ';
    template +=
      '<td> <input class="form-control" type="text" name="detail[' +
      sno +
      '][gothram]" value=""> </td> ';
    template +=
      '<td> <input class="form-control" type="text" name="detail[' +
      sno +
      '][natchathiram]" value=""> </td> ';
    template +=
      '<td> <input class="form-control date" type="text" name="detail[' +
      sno +
      '][abhishekam_date]" value="" /> </td> ';
    template +=
      '<td> <textarea class="form-control date" name="detail[' +
      sno +
      '][family]"></textarea> </td> ';
    template +=
      '<td> <button type="button" onclick="funMandalaSeasonRemoveItem(' +
      sno +
      ')" class="btn btn-danger"> <i class="fa fa-trash"> </i></button> </td> ';
    template += " </tr>";
    $("#tbodyReportEdit").append(template);
    // Initialize datepickers for newly added elements
    initializeDatepickers();
    sno++;
  }

  if (formType == 5) {
    template += '<tr class="trItem' + sno + '">';
    template +=
      '<td> <input class="form-control" type="text" name="detail[' +
      sno +
      '][name]" value=""> </td> ';
    template +=
      '<td> <input class="form-control" type="text" name="detail[' +
      sno +
      '][natchathiram]" value=""> </td> ';
    template +=
      '<td> <input class="form-control" type="text" name="detail[' +
      sno +
      '][gothram]" value=""> </td> ';
    template +=
      '<td> <button type="button" onclick="funMandalaSeasonRemoveItem(' +
      sno +
      ')" class="btn btn-danger"> <i class="fa fa-trash"> </i></button> </td> ';
    template += " </tr>";
    $("#tbodyReportEdit").append(template);
    // Initialize datepickers for newly added elements
    initializeDatepickers();
    sno++;
  }
  if (formType == 6) {
    template += '<tr class="trItem' + sno + '">';
    template +=
      '<td> <input class="form-control" type="text" name="detail[' +
      sno +
      '][full_name]" value=""> </td> ';
    template += "<td>";
    template +=
      ' <select class="form-control" name="detail[' +
      sno +
      '][adult_or_kid]"> ';
    template += '<option value="1"> Adult </option> ';
    template += '<option value="2"> kid </option>  ';
    template += "</select> </td>";
    template +=
      '<td> <input class="form-control date" type="text" name="detail[' +
      sno +
      '][steps_date]" value="" /> </td> ';
    template +=
      '<td> <button type="button" onclick="funMandalaSeasonRemoveItem(' +
      sno +
      ')" class="btn btn-danger"> <i class="fa fa-trash"> </i></button> </td> ';
    template += " </tr>";
    $("#tbodyReportEdit").append(template);
    // Initialize datepickers for newly added elements
    initializeDatepickers();
    sno++;
  }
}

/* Mandalam Dashboard */
function onFilterMandalamDashboard() {
  var fromDate = $("#filter_date_from").val();
  var toDate = $("#filter_date_to").val();
  var state = $("#filter_state").val();
  var city = $("#filter_city").val();

  $.ajax({
    type: "GET",
    url: baseURL + adminUrl + "/ajax/get-mandalam-dashboard-data",
    // dataType: "json",
    data:
      "_token=" +
      funGetToken() +
      "&state=" +
      state +
      "&ciy=" +
      city +
      "&fromDate=" +
      fromDate +
      "&toDate=" +
      toDate,
    success: function(response) {
      console.log("ajax response", response);

      $("#spanMalOnly").html(getChartTotal(response.data.chart1Data));
      $("#spanIrOnly").html(getChartTotal(response.data.chart2Data));
      $("#spanClimbing").html(getChartTotal(response.data.steps18));
      $("#spanWeekConOnly").html(
        getChartTotal(response.data.chart_WeekendPadiPoojaContribution)
      );
      $("#spanWeekFull").html(
        getChartTotal(response.data.chart_WeekendPadiPoojaFull)
      );
      $("#spanAnna").html(getChartTotal(response.data.chart_Annadanam));
      $("#spanDaily").html(getChartTotal(response.data.chart_DailyAbhishekam));

      $("#spanMal").html(getChartTotal(response.data.maladharanamirumudi1));
      $("#spanIru").html(getChartTotal(response.data.maladharanamirumudi2));

      loadChartData(
        "bar-chart-js",
        "chart1Data",
        response.data.chart1Data,
        "maladharnam_date"
      );
      loadChartData(
        "bar-chart-js1",
        "chart2Data",
        response.data.chart2Data,
        "irumudi_date"
      );
      loadChartData(
        "chart-18steps",
        "steps18",
        response.data.steps18,
        "steps_date"
      );
      loadChartData(
        "bar-chart-js2",
        "chart_WeekendPadiPoojaContribution",
        response.data.chart_WeekendPadiPoojaContribution,
        "event_date"
      );
      loadChartData(
        "bar-chart-js3",
        "chart_WeekendPadiPoojaFull",
        response.data.chart_WeekendPadiPoojaFull,
        "event_date"
      );
      loadChartData(
        "bar-chart-js4",
        "chart_Annadanam",
        response.data.chart_Annadanam,
        "event_date"
      );
      loadChartData(
        "bar-chart-js5",
        "chart_DailyAbhishekam",
        response.data.chart_DailyAbhishekam,
        "event_date"
      );

      loadChartData(
        "chart-maladharnam",
        "chartMaladharnam",
        response.data.maladharanamirumudi1,
        "maladharnam_date"
      );
      loadChartData(
        "chart-irumudi",
        "chartIrumudi",
        response.data.maladharanamirumudi2,
        "irumudi_date"
      );

      // loadChartDataMaladharnamIrumudi('chart-maladjarnam-irumudi','chartMaladharnamIrumudi',response.data.chartMaladharnamIrumudi,'maladharnam_date','irumudi_date');
    },
    error: function(err) {
      console.log(err);
      console.log("Error occured !!! Please try after sometime.");
    },
  });
}

function getChartTotal(data) {
  var total = 0;
  for (var i = 0; i < data.length; i++) {
    total += parseInt(data[i].counts);
  }
  return total;
}

function loadChartData(chartid, chartname, chartdata, label) {
  // 'rgba(255,99,132,1)',
  //                 'rgba(54, 162, 235, 1)',
  //                 'rgba(255, 206, 86, 1)',
  //                 'rgba(75, 192, 192, 1)',
  //                 'rgba(153, 102, 255, 1)',
  //                 'rgba(255, 159, 64, 1)'

  //                 colors
  //                 'rgba(255, 99, 132, 0.2)';
  //                 'rgba(54, 162, 235, 0.2)',
  //                 'rgba(255, 206, 86, 0.2)',
  //                 'rgba(75, 192, 192, 0.2)',
  //                 'rgba(153, 102, 255, 0.2)',
  //                 'rgba(255, 159, 64, 0.2)'

  if (chartid === "bar-chart-js") {
    var color = "rgba(255, 99, 132, 0.2)";
    var borderColor = "rgba(255,99,132,1)";
  }

  if (chartid === "bar-chart-js1") {
    var color = "rgba(153, 102, 255, 0.2)";
    var borderColor = "rgba(153, 102, 255, 1)";
  }

  if (chartid === "bar-chart-js2") {
    var color = "rgba(255, 206, 86, 0.2)";
    var borderColor = "rgba(255, 206, 86, 1)";
  }

  if (chartid === "bar-chart-js3") {
    var color = "rgba(75, 192, 192, 0.2)";
    var borderColor = "rgba(75, 192, 192, 1)";
  }

  if (chartid === "bar-chart-js4") {
    var color = "rgba(153, 102, 255, 0.2)";
    var borderColor = "rgba(153, 102, 255, 1)";
  }

  if (chartid === "bar-chart-js5") {
    var color = "rgba(255, 159, 64, 0.2)";
    var borderColor = "rgba(255, 159, 64, 1)";
  }

  if (chartid === "chart-maladharnam") {
    var color = "rgba(255, 99, 132, 0.2)";
    var borderColor = "rgba(255,99,132,1)";
  }

  if (chartid === "chart-irumudi") {
    var color = "rgba(153, 102, 255, 0.2)";
    var borderColor = "rgba(153, 102, 255, 1)";
  }

  if (chartid === "chart-18steps") {
    var color = "rgba(75, 192, 192, 0.2)";
    var borderColor = "rgba(75, 192, 192, 1)";
  }

  var responseData2 = chartdata;
  var chartOneArrayLabel = [];
  var chartOneArrayCount = [];
  $.each(responseData2, function(index, value) {
    chartOneArrayLabel.push(value[label]);
  });
  $.each(responseData2, function(index, value) {
    chartOneArrayCount.push(value.counts);
  });
  // var barChartData2 = {
  //       labels : chartOneArrayLabel,
  //       datasets : [
  //           {
  //               fillColor : "#4aa9e9",
  //               strokeColor : "#4aa9e9",
  //               data : chartOneArrayCount
  //           }
  //       ]

  //   }

  const formattedDateArray = chartOneArrayLabel.map((date) => {
    return formatDBDateToUsFormat(date);
  });

  var ctx = document.getElementById(chartid).getContext("2d");
  var myChart = new Chart(ctx, {
    type: "bar",
    data: {
      labels: formattedDateArray,
      datasets: [
        {
          label: "Count",
          data: chartOneArrayCount,
          backgroundColor: [color],
          borderColor: [borderColor],
          borderWidth: 1,
        },
      ],
    },
    options: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    },
  });

  // var myLine = new Chart(document.getElementById(chartid).getContext("2d")).Bar(barChartData2);
}

function loadChartDataMaladharnamIrumudi(
  chartid,
  chartname,
  chartdata,
  label1,
  label2
) {
  var MaladharnamData = chartdata[0];
  var chartArrayMaladharnamLabel = [];
  var chartArrayMaladharnamCount = [];
  $.each(MaladharnamData, function(index, value) {
    chartArrayMaladharnamLabel.push(value[label1]);
  });
  $.each(MaladharnamData, function(index, value) {
    chartArrayMaladharnamCount.push(value.counts);
  });

  var IrumudiData = chartdata[1];
  var chartArrayIrumudiLabel = [];
  var chartArrayIrumudiCount = [];
  $.each(IrumudiData, function(index, value) {
    chartArrayIrumudiLabel.push(value[label2]);
  });
  $.each(IrumudiData, function(index, value) {
    chartArrayIrumudiCount.push(value.counts);
  });

  let uniqueArr = chartArrayMaladharnamLabel
    .concat(chartArrayIrumudiLabel)
    .reduce((accumulator, currentValue) => {
      if (!accumulator.includes(currentValue)) {
        accumulator.push(currentValue);
      }
      return accumulator;
    }, []);
  console.log(uniqueArr);

  //array asc
  var isDescending = false;
  var sortedDateArray = uniqueArr.sort((a, b) =>
    isDescending
      ? new Date(b).getTime() - new Date(a).getTime()
      : new Date(a).getTime() - new Date(b).getTime()
  );

  console.log("sorted array", sortedDateArray);

  //array asc

  var chartDataSet = [];
  var chartDataSet2 = [];
  for (var i = 0; i < uniqueArr.length; i++) {
    console.log(MaladharnamData);
    var maladharnamCountForDate = MaladharnamData.find(
      (md) => md.maladharnam_date === uniqueArr[i]
    );
    if (maladharnamCountForDate) {
      chartDataSet.push(maladharnamCountForDate.counts);
    } else chartDataSet.push(0);
    var irumudiCountForDate = IrumudiData.find(
      (ird) => ird.irumudi_date === uniqueArr[i]
    );
    if (irumudiCountForDate) {
      chartDataSet2.push(irumudiCountForDate.counts);
    } else chartDataSet2.push(0);
  }

  console.log({ chartDataSet, chartDataSet2 });

  let combinedArr = [];

  uniqueArr.forEach((value) => {
    if (!chartArrayMaladharnamLabel.includes(value)) {
      chartArrayMaladharnamCount.push(0);
    } else {
    }
  });

  console.log("MaladharnamCount", chartArrayMaladharnamCount);

  uniqueArr.forEach((value) => {
    if (!chartArrayIrumudiLabel.includes(value)) {
      chartArrayIrumudiCount.push(0);
    } else {
      //chartArrayIrumudiCount.push(value.counts)
    }
  });

  console.log("irumudi count", chartArrayIrumudiCount);

  //irumudi array end

  const formattedDateArray = sortedDateArray.map((date) => {
    return formatDBDateToUsFormat(date);
  });

  var ctx = document.getElementById(chartid).getContext("2d");
  var myChart = new Chart(ctx, {
    type: "bar",
    data: {
      labels: formattedDateArray,
      datasets: [
        {
          label: "Maladharnam",
          data: chartDataSet,
          backgroundColor: "rgba(255, 99, 132, 0.2)",
          borderColor: "rgba(255,99,132,1)",
          borderWidth: 1,
        },
        {
          label: "Irumudi",
          data: chartDataSet2,
          backgroundColor: "rgba(153, 102, 255, 0.2)",
          borderColor: "rgba(153, 102, 255, 1)",
          borderWidth: 1,
        },
      ],
    },
    options: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    },
  });
}

function formatDBDateToUsFormat(date) {
  var dateArr = date.split("-");
  return dateArr[1] + "/" + dateArr[2] + "/" + dateArr[0];
}

function funGetCity(state) {
  if (state) {
    funShowLoader();
    $.ajax({
      // Ajax call
      type: "GET",
      url: baseURL + adminUrl + "/ajax/get-city",
      data: "_token=" + funGetToken() + "&state=" + state,
      success: function(response) {
        //console.log(response);
        funHideLoader();
        if (response) {
          $("#filter_city").empty();
          $("#filter_city").focus;
          $("#filter_city").append(
            '<option value="">-- Select City --</option>'
          );
          $.each(response.data, function(key, value) {
            $('select[name="filter_city"]').append(
              '<option value="' + value.city + '">' + value.city + "</option>"
            );
          });
        } else {
          $("#filter_city").empty();
        }
      },
    });
  } else {
    funHideLoader();
    $("#filter_city").empty();
  }
}

function gotoReport(path, product_id, irumudi) {
  var filter_date_from = document.getElementById("filter_date_from").value;
  var filter_date_to = document.getElementById("filter_date_to").value;
  var filter_state = document.getElementById("filter_state").value;
  //  if (filter_date_from != "") {
  if (irumudi)
    window.location.href =
      baseURL +
      adminUrl +
      path +
      "?filter_irumudi_date_from=" +
      filter_date_from +
      "&filter_irumudi_date_to=" +
      filter_date_to +
      "&filter_product=" +
      product_id +
      "&filter_state=" +
      filter_state;
  else
    window.location.href =
      baseURL +
      adminUrl +
      path +
      "?filter_date_from=" +
      filter_date_from +
      "&filter_date_to=" +
      filter_date_to +
      "&filter_product=" +
      product_id +
      "&filter_state=" +
      filter_state;

  // } else
  //alert('Oops.!!');
}

function funTableRowStatusChange(id) {
  var menuUrl = funGetValueWe("txtMenuUrl");
  var token = $("input[name='_token']").val();
  $.ajax({
    // Ajax call
    type: "POST",
    url: baseURL + adminUrl + "/ajax/change-status",
    data: "_token=" + token + "&menu_url=" + menuUrl + "&id=" + id,
    success: function(response) {
      if (response.status) {
        if (response.data.update == 1)
          $("#divStatus" + id).html(
            '<a class="badge badge-success text-white"> Enabled </a>'
          );
        else
          $("#divStatus" + id).html(
            '<a class="badge badge-danger text-white">Disabled</a>'
          );
      } else {
        funErrorMessage(response.message);
      }
    },
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    },
  });
}

function funFamilyDeleteRow(sno) {
  $("#family" + sno).remove();
}

function funCreateFamily() {
  var nachathiramData = funGetValueWe("nachathiramData");
  nachathiramData = JSON.parse(nachathiramData);
  var sno = funGetValueWe("txtSno");
  var template = "";
  template += "<tr id='family" + sno + "'> ";
  template +=
    '<td> <input type="text" name="family[' +
    sno +
    '][full_name]" class="form-control" value="" > </td> ';
  template +=
    '<td> <select class="form-control" name="family[' +
    sno +
    '][nachathiram_id]"> ';
  for (let i = 0; i < nachathiramData.length; i++)
    template +=
      ' <option value="' +
      nachathiramData[i].id +
      '"> ' +
      nachathiramData[i].nachathiram +
      " </option> ";

  template += "</select> </td>";
  template +=
    '<td> <button onclick="funFamilyDeleteRow(' +
    sno +
    ')" type="button" class="btn btn-danger"> <i class="fa fa-trash"></i>  </button> </td>';
  template += "</tr> ";

  $("#tbodyFamilyDetails").append(template);

  sno = parseInt(sno) + 1;

  funSetValue("txtSno", sno);
}

function funLiftimeCreateFamily() {
  var nachathiramData = funGetValueWe("nachathiramData");
  nachathiramData = JSON.parse(nachathiramData);
  var sno = funGetValueWe("txtSno");
  var template = "";
  template += "<tr id='family" + sno + "'> ";
  template +=
    '<td> <input type="text" name="family[' +
    sno +
    '][full_name]" class="form-control" value="" > </td> ';
  template +=
    '<td> <input type="text" name="family[' +
    sno +
    '][relationship]" class="form-control" value="" > </td> ';
  template +=
    '<td> <select class="form-control" name="family[' +
    sno +
    '][nachathiram]"> ';
  for (let i = 0; i < nachathiramData.length; i++)
    template +=
      ' <option value="' +
      nachathiramData[i].id +
      '"> ' +
      nachathiramData[i].nachathiram +
      " </option> ";

  template += "</select> </td>";
  template +=
    '<td> <button onclick="funFamilyDeleteRow(' +
    sno +
    ')" type="button" class="btn btn-danger"> <i class="fa fa-trash"></i>  </button> </td>';
  template += "</tr> ";

  $("#tbodyFamilyDetails").append(template);

  sno = parseInt(sno) + 1;

  funSetValue("txtSno", sno);
}

function funChangeSchedulingType(value) {
  switch (value) {
    case "by_week_day":
      $("#divByWeekDays").removeClass("hidden");
      $("#divAvailableDates").addClass("hidden");
      $("#divRestrictDates").addClass("hidden");
      break;

    case "allowed_dates":
      $("#divByWeekDays").addClass("hidden");
      $("#divAvailableDates").removeClass("hidden");
      $("#divRestrictDates").addClass("hidden");
      // Initialize datepickers for newly visible elements
      initializeDatepickers();
      break;

    case "restrict_dates":
      $("#divByWeekDays").addClass("hidden");
      $("#divAvailableDates").addClass("hidden");
      $("#divRestrictDates").removeClass("hidden");
      // Initialize datepickers for newly visible elements
      initializeDatepickers();
      break;

    default:
      $("#divByWeekDays").addClass("hidden");
      $("#divAvailableDates").addClass("hidden");
      $("#divRestrictDates").addClass("hidden");
      break;
  }
}

function funChangeWeekByDay(day) {
  if (daysEnabledByWeek.indexOf(day) > -1) {
    daysEnabledByWeek.splice(daysEnabledByWeek.indexOf(day), 1);
  } else {
    daysEnabledByWeek.push(day);
  }

  renderWeekDays();
}

function renderWeekDays() {
  if (daysEnabledByWeek.length > 0)
    $("#sectionDaysEnabledByWeek").removeClass("hidden");
  else $("#sectionDaysEnabledByWeek").addClass("hidden");
  $("#divShowWeekDays").html(daysEnabledByWeek.toString());
  funSetValue("txt_enabled_days_by_week", daysEnabledByWeek.toString());
}

function renderAvailableDates() {
  var _template = "";
  for (var i = 0; i < allowedDays.length; i++) {
    _template += "<tr>";
    _template += "<td> " + allowedDays[i] + " </td>";
    _template +=
      "<td style='text-align: right;'> <button type='button' class='btn btn-danger' onclick='removeAvailableDate(" +
      i +
      ")'> <i class='fa fa-trash-o'></i> </button> </td>";
    _template += "</tr>";
  }
  $("#tbodyAvailableDate").html(_template);
  if (allowedDays.length > 0) $("#sectionAvailableDates").removeClass("hidden");
  else $("#sectionAvailableDates").addClass("hidden");

  funSetValue("txt_available_dates", allowedDays.toString());
}

function removeAvailableDate(i) {
  allowedDays.splice(i, 1);
  renderAvailableDates();
}

function removeRestrictedDate(i) {
  restrictedDays.splice(i, 1);
  renderRestrictedDates();
}

function renderRestrictedDates() {
  var _template = "";
  for (var i = 0; i < restrictedDays.length; i++) {
    _template += "<tr>";
    _template += "<td> " + restrictedDays[i] + " </td>";
    _template +=
      "<td style='text-align: right;'> <button type='button' class='btn btn-danger' onclick='removeRestrictedDate(" +
      i +
      ")'> <i class='fa fa-trash-o'></i> </button> </td>";
    _template += "</tr>";
  }
  $("#tbodyRestrictedDate").html(_template);
  if (restrictedDays.length > 0)
    $("#sectionRestrictedDates").removeClass("hidden");
  else $("#sectionRestrictedDates").addClass("hidden");

  funSetValue("txt_restricted_dates", restrictedDays.toString());
}

function setAvailableDate() {
  var date = funGetValueWe("available_date");

  if (allowedDays.indexOf(date) === -1) {
    allowedDays.push(date);
  }

  funSetValue("available_date");

  renderAvailableDates();
}

function setRestrictedDate() {
  var date = funGetValueWe("restrict_date");

  if (restrictedDays.indexOf(date) === -1) {
    restrictedDays.push(date);
  }

  funSetValue("restrict_date");

  renderRestrictedDates();
}

function funIrumudiChangeSchedulingType(value) {
  switch (value) {
    case "by_week_day":
      $("#divIrumudiByWeekDays").removeClass("hidden");
      $("#divIrumudiAvailableDates").addClass("hidden");
      $("#divIrumudiRestrictDates").addClass("hidden");
      break;

    case "allowed_dates":
      $("#divIrumudiByWeekDays").addClass("hidden");
      $("#divIrumudiAvailableDates").removeClass("hidden");
      $("#divIrumudiRestrictDates").addClass("hidden");
      // Initialize datepickers for newly visible elements
      initializeDatepickers();
      break;

    case "restrict_dates":
      $("#divIrumudiByWeekDays").addClass("hidden");
      $("#divIrumudiAvailableDates").addClass("hidden");
      $("#divIrumudiRestrictDates").removeClass("hidden");
      // Initialize datepickers for newly visible elements
      initializeDatepickers();
      break;

    default:
      $("#divIrumudiByWeekDays").addClass("hidden");
      $("#divIrumudiAvailableDates").addClass("hidden");
      $("#divIrumudiRestrictDates").addClass("hidden");
      break;
  }
}

function funIrumudiChangeWeekByDay(day) {
  if (irumudiDaysEnabledByWeek.indexOf(day) > -1) {
    irumudiDaysEnabledByWeek.splice(irumudiDaysEnabledByWeek.indexOf(day), 1);
  } else {
    irumudiDaysEnabledByWeek.push(day);
  }

  renderIrumudiWeekDays();
}

function renderIrumudiWeekDays() {
  if (irumudiDaysEnabledByWeek.length > 0)
    $("#sectionIrumudiDaysEnabledByWeek").removeClass("hidden");
  else $("#sectionIrumudiDaysEnabledByWeek").addClass("hidden");
  $("#divIrumudiShowWeekDays").html(irumudiDaysEnabledByWeek.toString());
  funSetValue(
    "txt_irumudi_enabled_days_by_week",
    irumudiDaysEnabledByWeek.toString()
  );
}

function renderIrumudiAvailableDates() {
  var _template = "";
  for (var i = 0; i < irumudiAllowedDays.length; i++) {
    _template += "<tr>";
    _template += "<td> " + irumudiAllowedDays[i] + " </td>";
    _template +=
      "<td style='text-align: right;'> <button type='button' class='btn btn-danger' onclick='removeIrumudiAvailableDate(" +
      i +
      ")'> <i class='fa fa-trash-o'></i> </button> </td>";
    _template += "</tr>";
  }
  $("#tbodyIrumudiAvailableDate").html(_template);
  if (irumudiAllowedDays.length > 0)
    $("#sectionIrumudiAvailableDates").removeClass("hidden");
  else $("#sectionIrumudiAvailableDates").addClass("hidden");

  funSetValue("txt_irumudi_available_dates", irumudiAllowedDays.toString());
}

function removeIrumudiAvailableDate(i) {
  irumudiAllowedDays.splice(i, 1);
  renderIrumudiAvailableDates();
}

function removeIrumudiRestrictedDate(i) {
  irumudiRestrictedDays.splice(i, 1);
  renderIrumudiRestrictedDates();
}

function renderIrumudiRestrictedDates() {
  var _template = "";
  for (var i = 0; i < irumudiRestrictedDays.length; i++) {
    _template += "<tr>";
    _template += "<td> " + irumudiRestrictedDays[i] + " </td>";
    _template +=
      "<td style='text-align: right;'> <button type='button' class='btn btn-danger' onclick='removeIrumudiRestrictedDate(" +
      i +
      ")'> <i class='fa fa-trash-o'></i> </button> </td>";
    _template += "</tr>";
  }
  $("#tbodyIrumudiRestrictedDate").html(_template);
  if (irumudiRestrictedDays.length > 0)
    $("#sectionIrumudiRestrictedDates").removeClass("hidden");
  else $("#sectionIrumudiRestrictedDates").addClass("hidden");

  funSetValue("txt_irumudi_restricted_dates", irumudiRestrictedDays.toString());
}

function setIrumudiAvailableDate() {
  var date = funGetValueWe("irumudi_available_date");

  if (irumudiAllowedDays.indexOf(date) === -1) {
    irumudiAllowedDays.push(date);
  }

  funSetValue("irumudi_available_date");

  renderIrumudiAvailableDates();
}

function setIrumudiRestrictedDate() {
  var date = funGetValueWe("irumudi_restrict_date");

  if (irumudiRestrictedDays.indexOf(date) === -1) {
    irumudiRestrictedDays.push(date);
  }

  funSetValue("irumudi_restrict_date", "");

  renderIrumudiRestrictedDates();
}

function funAddDineInSlots() {
  var timeSlot = funGetValueWe("txtDineInTimeSlot");
  var maxAllowed = funGetValueWe("txtDineInMaxAllowed");
  var dineInSno = funGetValueWe("txtDineSno");
  dineSno = dineInSno;

  var obj = {
    time_slot: timeSlot,
    max_allowed: maxAllowed,
  };
  onamSadyaDineInTimeSlots.push(obj);
  onamSadyaSlotObj.dineInSlot = onamSadyaDineInTimeSlots;
  // console.log({onamSadyaSlotObj});
  var _template =
    '<div class="row" style="margin-top: 15px;" id="dineInSlotsContainer' +
    dineSno +
    '"><div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" name="dineInTime' +
    dineSno +
    '" value="' +
    timeSlot +
    '">';
  _template += '</div> <div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" name="dineInMax' +
    dineSno +
    '" value="' +
    maxAllowed +
    '">';
  _template += '</div><div class="col-md-1">';
  _template +=
    '<button type="button" class="btn btn-danger btn-sm" onclick="funRemoveDineInSlots(' +
    dineSno +
    ')"><i class="fa fa-trash"></i></button>';
  $("#showDineInSlots").append(_template);
  dineSno++;
  funSetValue("txtDineInTimeSlot", "");
  funSetValue("txtDineInMaxAllowed", "");
  funSetValue(
    "txtDineInTimeSlotList",
    JSON.stringify(onamSadyaDineInTimeSlots)
  );
  funSetValue("txtOnamSadyaSlots", JSON.stringify(onamSadyaSlotObj));

  dineSno = parseInt(dineSno) + 1;
  funSetValue("txtDineSno", dineSno);
  // console.log({onamSadyaDineInTimeSlots});
}

function funRemoveDineInSlots(dineSno) {
  onamSadyaDineInTimeSlots.splice(dineSno, 1);
  onamSadyaSlotObj.dineInSlot = onamSadyaDineInTimeSlots;
  funSetValue(
    "txtDineInTimeSlotList",
    JSON.stringify(onamSadyaDineInTimeSlots)
  );
  funSetValue("txtOnamSadyaSlots", JSON.stringify(onamSadyaSlotObj));
  // console.log("remove---", {onamSadyaDineInTimeSlots, onamSadyaSlotObj});
  $("#dineInSlotsContainer" + dineSno).remove();
}

function funAddTakeAwaySlots() {
  var timeSlot = funGetValueWe("txtTakeAwayTimeSlot");
  var maxAllowed = funGetValueWe("txtTakeAwayMaxAllowed");
  var takeAwaySno = funGetValueWe("txtTakeSno");
  takeSno = takeAwaySno;

  var obj = {
    time_slot: timeSlot,
    max_allowed: maxAllowed,
  };
  onamSadyaTakeAwayTimeSlots.push(obj);
  onamSadyaSlotObj.takeAwaySlot = onamSadyaTakeAwayTimeSlots;

  var _template =
    '<div class="row" style="margin-top: 15px;" id="takeAwaySlotsContainer' +
    takeSno +
    '"><div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" name="takeAwayTime' +
    dineSno +
    '" value="' +
    timeSlot +
    '">';
  _template += '</div> <div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" name="takeAwayMax' +
    dineSno +
    '" value="' +
    maxAllowed +
    '">';
  _template += '</div><div class="col-md-1">';
  _template +=
    '<button type="button" class="btn btn-danger btn-sm" onclick="funRemoveTakeAwaySlots(' +
    takeSno +
    ')"><i class="fa fa-trash"></i></button>';
  $("#showTakeAwaySlots").append(_template);
  takeSno++;

  funSetValue("txtTakeAwayTimeSlot", "");
  funSetValue("txtTakeAwayMaxAllowed", "");
  funSetValue(
    "txtTakeAwaySlotList",
    JSON.stringify(onamSadyaTakeAwayTimeSlots)
  );
  funSetValue("txtOnamSadyaSlots", JSON.stringify(onamSadyaSlotObj));

  takeSno = parseInt(takeSno) + 1;
  funSetValue("txtTakeSno", takeSno);
}

function funRemoveTakeAwaySlots(takeSno) {
  onamSadyaTakeAwayTimeSlots.splice(takeSno, 1);
  onamSadyaSlotObj.takeAwaySlot = onamSadyaTakeAwayTimeSlots;
  funSetValue(
    "txtTakeAwaySlotList",
    JSON.stringify(onamSadyaTakeAwayTimeSlots)
  );
  funSetValue("txtOnamSadyaSlots", JSON.stringify(onamSadyaSlotObj));
  $("#takeAwaySlotsContainer" + takeSno).remove();
}

function funAddDineInSlotsV2() {
  var emptyDineInSlot = {
    slot: "",
    maxAllowed: "",
  };

  var index = onamSadyaDineInTimeSlots.length;
  onamSadyaDineInTimeSlots.push(emptyDineInSlot);
  funRenderDineInSlot(index, "", "");
}

function funRenderDineInSlot(index, slot, maxAllowed, slotData) {
  var _template =
    '<div class="row" style="margin-top: 15px;" id="dineInSlotsContainer' +
    index +
    '"><div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" onkeyup="funChangeDineIn(' +
    index +
    ', 1, this.value)" name="dineInTime' +
    index +
    '" value="' +
    slot +
    '">';
  _template += '</div> <div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" onkeyup="funChangeDineIn(' +
    index +
    ', 2, this.value)" name="dineInMax' +
    index +
    '" value="' +
    maxAllowed +
    '">';
  _template += '</div> <div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control"  readonly value="' +
    (slotData?.available || 0) +
    '">';
  _template += '</div><div class="col-md-1">';
  _template +=
    '<button type="button" class="btn btn-danger btn-sm" onclick="funRemoveDineInSlotsV2(' +
    index +
    ')"><i class="fa fa-trash"></i></button>';
  $("#showDineInSlots").append(_template);
}

function funChangeDineIn(index, type, value) {
  console.log({ index, type });
  if (type == 1) {
    onamSadyaDineInTimeSlots[index].slot = value;
  } else onamSadyaDineInTimeSlots[index].maxAllowed = value;

  console.log({ onamSadyaDineInTimeSlots });
  setTimeSlotData();
}

function funRemoveDineInSlotsV2(index) {
  onamSadyaDineInTimeSlots.splice(index, 1);
  $("#dineInSlotsContainer" + index).remove();
  setTimeSlotData();
  reRenderDineInSlots();
}

function reRenderDineInSlots() {
  $("#showDineInSlots").html("");
  for (var i = 0; i < onamSadyaDineInTimeSlots.length; i++) {
    funRenderDineInSlot(
      i,
      onamSadyaDineInTimeSlots[i].slot,
      onamSadyaDineInTimeSlots[i].maxAllowed,
      onamSadyaDineInTimeSlots[i]
    );
  }
}

function reRenderTakeAwaySlots() {
  $("#showTakeAwaySlots").html("");
  for (var i = 0; i < onamSadyaTakeAwayTimeSlots.length; i++) {
    funRenderTakeAwaySlot(
      i,
      onamSadyaTakeAwayTimeSlots[i].slot,
      onamSadyaTakeAwayTimeSlots[i].maxAllowed,
      onamSadyaTakeAwayTimeSlots[i]
    );
  }
}

function setTimeSlotData() {
  var slotData = {
    dineInSlots: onamSadyaDineInTimeSlots,
    takeAwaySlots: onamSadyaTakeAwayTimeSlots,
  };
  funSetValue("txtTimeSlotData", JSON.stringify(slotData));
}

function funAddTakeAwaySlotsV2() {
  var emptyTakeAwaySlot = {
    slot: "",
    maxAllowed: "",
  };

  var index = onamSadyaTakeAwayTimeSlots.length;
  onamSadyaTakeAwayTimeSlots.push(emptyTakeAwaySlot);
  funRenderTakeAwaySlot(index, "", "");
}

function funRemoveTakeAwaySlotsV2(index) {
  onamSadyaTakeAwayTimeSlots.splice(index, 1);
  $("#takeAwayContainer" + index).remove();
  setTimeSlotData();
  reRenderTakeAwaySlots();
}

function funRenderTakeAwaySlot(index, slot, maxAllowed, slotData) {
  var _template =
    '<div class="row" style="margin-top: 15px;" id="takeAwayContainer' +
    index +
    '"><div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" onkeyup="funChangeTakeAway(' +
    index +
    ', 1, this.value)" name="txtTakeAwayTime' +
    index +
    '" value="' +
    slot +
    '">';
  _template += '</div> <div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" onkeyup="funChangeTakeAway(' +
    index +
    ', 2, this.value)" name="txtTakeAwayMax' +
    index +
    '" value="' +
    maxAllowed +
    '">';
  _template += '</div> <div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control"  readonly value="' +
    (slotData?.available || 0) +
    '">';
  _template += '</div><div class="col-md-1">';
  _template +=
    '<button type="button" class="btn btn-danger btn-sm" onclick="funRemoveTakeAwaySlotsV2(' +
    index +
    ')"><i class="fa fa-trash"></i></button>';
  $("#showTakeAwaySlots").append(_template);
}

function funChangeTakeAway(index, type, value) {
  console.log({ index, type });
  if (type == 1) {
    onamSadyaTakeAwayTimeSlots[index].slot = value;
  } else onamSadyaTakeAwayTimeSlots[index].maxAllowed = value;

  console.log({ onamSadyaTakeAwayTimeSlots });
  setTimeSlotData();
}

function funChangeMemberSchedulingType(value) {
  if (value == "enabled") $("#divMemberTypeScheduling").removeClass("hidden");
  else $("#divMemberTypeScheduling").addClass("hidden");
}

$(".auto-customer-name").autocomplete({
  lookup: function(query, done) {
    $.ajax({
      // Ajax call
      type: "GET",
      dataType: "JSON",
      url: baseURL + adminUrl + "/ajax/auto-customer-name",
      data: "q=" + query,
      success: function(response) {
        var result = {
          suggestions: response,
        };
        done(result);
      },
      error: function() {
        funErrorMessage("Error occured !!! Please try after sometime.");
      },
    });
  },
  onSelect: function(suggestion) {
    console.log(suggestion.data.id);
    funSetValue("customer_id", suggestion.data.id);
  },
  minChars: 1,
});

function funRenderOnamSadyaDineInReport(data) {
  var _template = "";
  for (var i = 0; i < data.length; i++) {
    _template += '<div class="row" style="margin-top: 15px;">';
    _template += '<div class="col-md-2"> ' + data[i].slot + " </div>";
    _template += '<div class="col-md-2">';
    _template +=
      '<input type="text" class="form-control" onkeyup="funSetOnamSadyaReportEdit(1, ' +
      i +
      ', this.value)" id="txtDineInSlot' +
      i +
      '" value="' +
      (data[i]?.slot_count || 0) +
      '"> ';
    _template += "</div>";
    _template += '<div class="col-md-2">';
    _template +=
      '<input type="text" class="form-control" onkeyup="funSetOnamSadyaReportEdit(2, ' +
      i +
      ', this.value)" id="txtDineKidInSlot' +
      i +
      '" value="' +
      (data[i]?.kids_slot_count || 0) +
      '"> ';
    _template += "</div>";
    _template += "</div>";
  }
  $("#divDineInSlots").append(_template);
}

function funRenderOnamSadyaTakeAwayReport(data) {
  var _template = "";
  for (var i = 0; i < data.length; i++) {
    _template += '<div class="row" style="margin-top: 15px;">';
    _template += '<div class="col-md-2"> ' + data[i].slot + " </div>";
    _template += '<div class="col-md-2">';
    _template +=
      '<input type="text" class="form-control" onkeyup="funSetOnamSadyaReportEdit(3, ' +
      i +
      ', this.value)" id="txtDineInSlot' +
      i +
      '" value="' +
      (data[i]?.slot_count || 0) +
      '"> ';
    _template += "</div>";
    _template += "</div>";
  }
  $("#divTakeAwaySlots").append(_template);
}

function funSetOnamSadyaReportEdit(type, index, value) {
  if (type == 1) {
    onamSadyaDineInTimeSlots[index].slot_count = value;
  }

  if (type == 2) onamSadyaDineInTimeSlots[index].kids_slot_count = value;

  if (type == 3) onamSadyaTakeAwayTimeSlots[index].slot_count = value;

  funSetValue("txtDiningSlots", JSON.stringify(onamSadyaDineInTimeSlots));
  funSetValue("txtTakeAwaySlots", JSON.stringify(onamSadyaTakeAwayTimeSlots));
}

function funAddVolunteerActivites() {
  var emptyVolunteerEvents = {
    activities: "",
    sortOrder: "",
    maxAllowed: "",
    message: "",
    status: "1",
  };

  var index = volunteerActivities.length;
  volunteerActivities.push(emptyVolunteerEvents);
  funRenderVolunteerActivites(index, "", "", "", "", 1);
}

function funRenderVolunteerActivites(
  index,
  activities,
  sortOrder,
  maxAllowed,
  message,
  status
) {
  var _template =
    '<div class="row" style="margin-top: 15px;" id="volunteerActivitiesContainer' +
    index +
    '"><div class="col-md-3">';
  _template +=
    '<input type="text" class="form-control"placeholder = "Activity" onkeyup="funChangeActivities(' +
    index +
    ',1, this.value)" name="volunteerActivities' +
    index +
    '" value="' +
    activities +
    '">';
  _template += '</div><div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" placeholder = "Sort order" onkeyup="funChangeActivities(' +
    index +
    ',2, this.value)" name="volunteerActivitiesSortOrder' +
    index +
    '" value="' +
    (sortOrder || "") +
    '">';
  _template += '</div><div class="col-md-2" style="display: none">';
  _template +=
    '<input type="text" class="form-control" placeholder = "Max Allowed" onkeyup="funChangeActivities(' +
    index +
    ',3, this.value)" name="volunteerActivitiesMaxAllowed' +
    index +
    '" value="' +
    (maxAllowed || "") +
    '">';
  _template += '</div><div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" placeholder = "Message" onkeyup="funChangeActivities(' +
    index +
    ',4, this.value)" name="volunteerActivitiesMessage' +
    index +
    '" value="' +
    (message || "") +
    '">';
  _template += '</div><div class="col-md-2">';
  _template +=
    '<select class="form-control"  name="volunteerActivitiesStatus' +
    index +
    '" id = "volunteerActivitiesStatus' +
    index +
    '" onChange="funChangeActivities(' +
    index +
    ',5, this.value)" > ';
  _template +=
    "<option " +
    (status == "1" ? "selected" : "") +
    ' value="' +
    1 +
    '"> Enabled </option> ';
  _template +=
    "<option " +
    (status == "0" ? "selected" : "") +
    ' value="' +
    0 +
    '"> Disabled </option> ';
  _template += "</select>  ";
  _template += '</div><div class="col-md-1">';
  _template +=
    '<button type="button" class="btn btn-danger btn-sm" onclick="funRemoveVolunteerActivities(' +
    index +
    ')"><i class="fa fa-trash"></i></button>';
  $("#showVolunteerActivities").append(_template);
}

function funChangeActivities(index, type, value) {
  console.log({ index, type });
  if (type == 1) {
    volunteerActivities[index].activities = value;
  } else if (type == 2) {
    volunteerActivities[index].sortOrder = value;
  } else if (type == 3) {
    volunteerActivities[index].maxAllowed = value;
  } else if (type == 4) {
    volunteerActivities[index].message = value;
  } else {
    volunteerActivities[index].status = value;
  }

  console.log({ volunteerActivities });
  setActivitiesData();
}

function setActivitiesData() {
  var activitiesData = {
    activities: volunteerActivities,
  };
  funSetValue("txtActivitiesData", JSON.stringify(activitiesData));
}

function funRemoveVolunteerActivities(index) {
  console.log({ activityTimings, act: volunteerActivities[index].activities });
  delete activityTimings[volunteerActivities[index].activities];
  volunteerActivities.splice(index, 1);
  $("#divActivity" + index).remove();
  $("#volunteerActivitiesContainer" + index).remove();
  setActivitiesData();
  reRenderVolunteerActivities();
  funSetValue("txtActivityTiming", JSON.stringify(activityTimings));
}

function reRenderVolunteerActivities() {
  $("#showVolunteerActivities").html("");
  for (var i = 0; i < volunteerActivities.length; i++) {
    funRenderVolunteerActivites(
      i,
      volunteerActivities[i].activities,
      volunteerActivities[i].sortOrder,
      volunteerActivities[i].maxAllowed,
      volunteerActivities[i].message,
      volunteerActivities[i].status
    );
  }
}

function funAddVolunteerTiming() {
  var emptyVolunteerSlot = {
    slot: "",
  };

  var index = volunteerTiming.length;
  volunteerTiming.push(emptyVolunteerSlot);
  funRenderVolunteerTiming(index, "");
}

function funRenderVolunteerTiming(index, slot) {
  var _template =
    '<div class="row" style="margin-top: 15px;" id="volunteerSlotContainer' +
    index +
    '"><div class="col-md-6">';
  _template +=
    '<input type="text" class="form-control" onkeyup="funChangeVoluteerTiming(' +
    index +
    ', this.value)" name="volunteerTiming' +
    index +
    '" value="' +
    slot +
    '">';
  _template += '</div><div class="col-md-1">';
  _template +=
    '<button type="button" class="btn btn-danger btn-sm" onclick="funRemoveVolunteerTiming(' +
    index +
    ')"><i class="fa fa-trash"></i></button>';
  $("#showVolunteerTiming").append(_template);
}

function funRemoveVolunteerTiming(index) {
  volunteerTiming.splice(index, 1);
  console.log({ volunteerTiming });
  $("#volunteerSlotContainer" + index).remove();
  setVolunteerTimingData();
  reRenderVolunteerTiming();
}

function funChangeVoluteerTiming(index, value) {
  volunteerTiming[index].slot = value;

  console.log({ volunteerTiming });
  setVolunteerTimingData();
}

function setVolunteerTimingData() {
  var slotData = {
    slot: volunteerTiming,
  };
  funSetValue("txtSlotData", JSON.stringify(slotData));
}

function reRenderVolunteerTiming() {
  $("#showVolunteerTiming").html("");
  for (var i = 0; i < volunteerTiming.length; i++) {
    funRenderVolunteerTiming(i, volunteerTiming[i].slot);
  }
}

function funChangeVolunteerActivity(value) {
  var selectedItemIndex = selectedActivities.findIndex((act) => act === value);
  if (selectedItemIndex > 0) {
    selectedActivities.splice(selectedItemIndex, 1);
  } else selectedActivities.push(value);

  funSetValue("txtActivitiesSelected", selectedActivities.toString());
}

function funChangeVolunteerTiming(value) {
  var selectedTimeIndex = selectedTimings.findIndex((time) => time === value);
  if (selectedTimeIndex > 0) {
    selectedTimings.splice(selectedTimeIndex, 1);
  } else selectedTimings.push(value);

  funSetValue("txttimingsSelected", selectedTimings.toString());
}

function renderTimeSchedulingContent() {
  console.log({ volunteerActivities });
  var _template = "";
  var empty = "";
  for (var i = 0; i < volunteerActivities.length; i++) {
    _template += '<div id="divActivity' + i + '" style="margin-bottom: 20px;">';
    _template +=
      "<header> <b> " +
      volunteerActivities[i].activities +
      ' </b> <span> <button style="margin-left: 15px;" type="button" class="btn btn-primary" onclick="funAddTiming(' +
      i +
      ",'" +
      empty +
      "','" +
      empty +
      "', '" +
      empty +
      "')\"> Add </button> </header>";
    _template += '<div class="row" style="margin-top: 20px">';
    _template += '<div class="col-md-5"> Time </div>';
    _template += '<div class="col-md-2"> Max count </div>';
    _template += '<div class="col-md-2"> Available </div>';
    _template += "</div>";
    _template +=
      '<div id="divActivityTiming' + i + '" style="margin-top: 20px;"> </div>';
    _template += "</div>";
  }
  $("#divTimingContent").html(_template);
}

function funAddTiming(i, value, index, maxCount) {
  var timingIndex = index;
  if (index == "") {
    var timingData = {
      timing: value,
      maxCount: 1,
    };
    timingIndex = activityTimings[volunteerActivities[i].activities].length;
    activityTimings[volunteerActivities[i].activities].push(timingData);
  }

  console.log(i, value, timingIndex, { activityTimings });

  var _template = "";

  _template +=
    '<div style="margin-bottom: 20px" class="row" id="divTiming' +
    i +
    "-" +
    timingIndex +
    '"> ';
  _template +=
    '<div class="col-md-5"> <input placeholder="Time" onkeyup="funChangeTimingText(' +
    i +
    ", " +
    timingIndex +
    ', this.value, 1)" value="' +
    value +
    '" type="text" class="form-control" /> </div>';
  _template +=
    '<div class="col-md-2"> <input placeholder="Max count" onkeyup="funChangeTimingText(' +
    i +
    ", " +
    timingIndex +
    ', this.value, 2)" value="' +
    maxCount +
    '" type="text" class="form-control" /> </div>';
  _template +=
    '<div class="col-md-2"> <input readonly placeholder="Available" value="" type="text" class="form-control" /> </div>';
  _template +=
    '<div class="col-md-1"> <button class="btn btn-danger" onclick="funDeleteTiming(' +
    i +
    "," +
    timingIndex +
    ')" type="button"> <i class="fa fa-trash" /> </button> </div>';
  _template += "</div> ";

  $("#divActivityTiming" + i).append(_template);
}

function funChangeTimingText(activityIndex, timingIndex, value, type) {
  // console.log({ activityIndex, timingIndex})
  if (type === 1)
    activityTimings[volunteerActivities[activityIndex].activities][
      timingIndex
    ].timing = value;
  else
    activityTimings[volunteerActivities[activityIndex].activities][
      timingIndex
    ].maxCount = value;
  funSetValue("txtActivityTiming", JSON.stringify(activityTimings));
}

function funDeleteTiming(activityIndex, timingIndex) {
  activityTimings[volunteerActivities[activityIndex].activities].splice(
    timingIndex,
    1
  );
  $("#divTiming" + activityIndex + "-" + timingIndex).remove();

  funSetValue("txtActivityTiming", JSON.stringify(activityTimings));

  funReRenderActivityTimings(activityIndex);
}

function funReRenderActivityTimings(activityIndex) {
  $("#divActivityTiming" + activityIndex).html("");
  console.log({
    activityTimings:
      activityTimings[volunteerActivities[activityIndex].activities],
    length:
      activityTimings[volunteerActivities[activityIndex].activities].length,
  });
  for (
    var i = 0;
    i < activityTimings[volunteerActivities[activityIndex].activities].length;
    i++
  ) {
    // console.log(activityTimings[volunteerActivities[activityIndex].activities][i].timing);
    // funAddTiming(activityIndex, activityTimings[volunteerActivities[activityIndex].activities][i].timing, i);

    var _template = "";

    _template +=
      '<div style="margin-bottom: 20px" class="row" id="divTiming' +
      activityIndex +
      "-" +
      i +
      '"> ';
    _template +=
      '<div class="col-md-5"> <input placeholder="Time" onkeyup="funChangeTimingText(' +
      activityIndex +
      ", " +
      i +
      ', this.value, 1)" value="' +
      activityTimings[volunteerActivities[activityIndex].activities][i].timing +
      '" type="text" class="form-control" /> </div>';
    _template +=
      '<div class="col-md-2"> <input placeholder="Max count" onkeyup="funChangeTimingText(' +
      activityIndex +
      ", " +
      i +
      ', this.value, 2)" value="' +
      (activityTimings[volunteerActivities[activityIndex].activities][i]
        .maxCount || "") +
      '" type="text" class="form-control" /> </div>';
    _template +=
      '<div class="col-md-2"> <input readonly placeholder="Available" value="' +
      (activityTimings[volunteerActivities[activityIndex].activities][i]
        .available || "0") +
      '" type="text" class="form-control" /> </div>';
    _template +=
      '<div class="col-md-1"> <button class="btn btn-danger" onclick="funDeleteTiming(' +
      activityIndex +
      "," +
      i +
      ')" type="button"> <i class="fa fa-trash" /> </button> </div>';
    _template += "</div> ";

    $("#divActivityTiming" + activityIndex).append(_template);
  }
}

function funTimingChanges(activities, timings = null) {
  console.log(activities);
  $.ajax({
    // Ajax call
    type: "GET",
    dataType: "JSON",
    url: baseURL + adminUrl + "/ajax/get-timings",
    data: "activities=" + activities,
    success: function(response) {
      console.log(response);
      if (response) {
        $("#filter_timings").empty();
        $("#filter_timings").focus;
        $("#filter_timings").append('<option value="">- Timings -</option>');
        $.each(response, function(key, value) {
          $('select[name="filter_timings"]').append(
            "<option " +
              (timings == value.timing ? "selected" : "") +
              ' value="' +
              value.timing +
              '">' +
              value.timing +
              "</option>"
          );
        });
      } else {
        $("#filter_timings").empty();
      }
    },
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    },
  });
}

function funActivityChanges(activityStatus, activities = null) {
  console.log(activityStatus);
  $.ajax({
    // Ajax call
    type: "GET",
    dataType: "JSON",
    url: baseURL + adminUrl + "/ajax/get-activities",
    data: "status=" + activityStatus,
    success: function(response) {
      console.log(response);
      if (response) {
        $("#filter_activities").empty();
        $("#filter_activities").focus;
        $("#filter_activities").append(
          '<option value=""> - Activity - </option>'
        );
        $.each(response, function(key, value) {
          $('select[name="filter_activities"]').append(
            "<option " +
              (activities == value ? "selected" : "") +
              ' value="' +
              value +
              '">' +
              value +
              "</option>"
          );
        });
      } else {
        $("#filter_activities").empty();
      }
    },
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    },
  });
}

// \''+data.attribute_name.name+'\'

function funAddContestActivites() {
  var emptyContestEvents = {
    activities: "",
    sortOrder: "",
    maxAllowed: "",
    message: "",
    status: "1",
  };

  var index = contestActivities.length;
  contestActivities.push(emptyContestEvents);
  funRenderContestActivites(index, "", "", "", "", 1);
}

function funRenderContestActivites(
  index,
  activities,
  sortOrder,
  maxAllowed,
  message,
  status
) {
  var _template =
    '<div class="row" style="margin-top: 15px;" id="contestActivitiesContainer' +
    index +
    '"><div class="col-md-3">';
  _template +=
    '<input type="text" class="form-control"placeholder = "Contest" onkeyup="funChangeContestActivities(' +
    index +
    ',1, this.value)" name="contestActivities' +
    index +
    '" value="' +
    activities +
    '">';
  _template += '</div><div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" placeholder = "Sort order" onkeyup="funChangeContestActivities(' +
    index +
    ',2, this.value)" name="contestActivitiesSortOrder' +
    index +
    '" value="' +
    (sortOrder || "") +
    '">';
  _template += '</div><div class="col-md-2" style="display: none">';
  _template +=
    '<input type="text" class="form-control" placeholder = "Max Allowed" onkeyup="funChangeContestActivities(' +
    index +
    ',3, this.value)" name="contestActivitiesMaxAllowed' +
    index +
    '" value="' +
    (maxAllowed || "") +
    '">';
  _template += '</div><div class="col-md-2">';
  _template +=
    '<input type="text" class="form-control" placeholder = "Message" onkeyup="funChangeContestActivities(' +
    index +
    ',4, this.value)" name="contestActivitiesMessage' +
    index +
    '" value="' +
    (message || "") +
    '">';
  _template += '</div><div class="col-md-2">';
  _template +=
    '<select class="form-control"  name="contestActivitiesStatus' +
    index +
    '" id = "contestActivitiesStatus' +
    index +
    '" onChange="funChangeContestActivities(' +
    index +
    ',5, this.value)" > ';
  _template +=
    "<option " +
    (status == "1" ? "selected" : "") +
    ' value="' +
    1 +
    '"> Enabled </option> ';
  _template +=
    "<option " +
    (status == "0" ? "selected" : "") +
    ' value="' +
    0 +
    '"> Disabled </option> ';
  _template += "</select>  ";
  _template += '</div><div class="col-md-1">';
  _template +=
    '<button type="button" class="btn btn-danger btn-sm" onclick="funRemoveContestActivities(' +
    index +
    ')"><i class="fa fa-trash"></i></button>';
  $("#showContestActivities").append(_template);
}

function funChangeContestActivities(index, type, value) {
  console.log({ index, type });
  if (type == 1) {
    contestActivities[index].activities = value;
  } else if (type == 2) {
    contestActivities[index].sortOrder = value;
  } else if (type == 3) {
    contestActivities[index].maxAllowed = value;
  } else if (type == 4) {
    contestActivities[index].message = value;
  } else {
    contestActivities[index].status = value;
  }

  console.log({ contestActivities });
  setContestActivitiesData();
}

function setContestActivitiesData() {
  var activitiesData = {
    activities: contestActivities,
  };
  funSetValue("txtActivitiesData", JSON.stringify(activitiesData));
}

function funRemoveContestActivities(index) {
  console.log({ activityTimings, act: contestActivities[index].activities });
  delete activityTimings[contestActivities[index].activities];
  contestActivities.splice(index, 1);
  $("#divActivity" + index).remove();
  $("#contestActivitiesContainer" + index).remove();
  setContestActivitiesData();
  reRenderContestActivities();
  funSetValue("txtActivityTiming", JSON.stringify(activityTimings));
}

function reRenderContestActivities() {
  $("#showContestActivities").html("");
  for (var i = 0; i < contestActivities.length; i++) {
    funRenderContestActivites(
      i,
      contestActivities[i].activities,
      contestActivities[i].sortOrder,
      contestActivities[i].maxAllowed,
      contestActivities[i].message,
      contestActivities[i].status
    );
  }
}

function funAddContestTiming() {
  var emptyContestSlot = {
    slot: "",
    maxCount: "",
  };

  var index = contestTiming.length;
  contestTiming.push(emptyContestSlot);
  funRenderContestTiming(index, "", "");
}

function funRenderContestTiming(index, slot, maxCount) {
  var _template =
    '<div class="row" style="margin-top: 15px;" id="contestSlotContainer' +
    index +
    '"><div class="col-md-6">';
  _template +=
    '<input type="text" class="form-control" onkeyup="funChangeContestTimings(' +
    index +
    ', this.value)" name="contestTiming' +
    index +
    '" value="' +
    slot +
    '">';
  _template += '</div><div class="col-md-1">';
  _template +=
    '<button type="button" class="btn btn-danger btn-sm" onclick="funRemoveContestTiming(' +
    index +
    ')"><i class="fa fa-trash"></i></button>';
  $("#showContestTiming").append(_template);
}

function funRemoveContestTiming(index) {
  contestTiming.splice(index, 1);
  console.log({ contestTiming });
  $("#contestSlotContainer" + index).remove();
  setContestTimingData();
  reRenderContestTiming();
}

function funChangeContestTimings(index, value) {
  contestTiming[index].slot = value;

  console.log({ contestTiming });
  setContestTimingData();
}

function setContestTimingData() {
  var slotData = {
    slot: contentTiming,
  };
  funSetValue("txtSlotData", JSON.stringify(slotData));
}

function reRenderContestTiming() {
  $("#showContestTiming").html("");
  for (var i = 0; i < contestTiming.length; i++) {
    funRenderContestTiming(i, contestTiming[i].slot);
  }
}

function funChangeContestActivity(value) {
  var selectedItemIndex = selectedActivities.findIndex((act) => act === value);
  if (selectedItemIndex > 0) {
    selectedActivities.splice(selectedItemIndex, 1);
  } else selectedActivities.push(value);

  funSetValue("txtActivitiesSelected", selectedActivities.toString());
}

function funChangeContestTiming(value) {
  var selectedTimeIndex = selectedTimings.findIndex((time) => time === value);
  if (selectedTimeIndex > 0) {
    selectedTimings.splice(selectedTimeIndex, 1);
  } else selectedTimings.push(value);

  funSetValue("txttimingsSelected", selectedTimings.toString());
}

function renderContestTimeSchedulingContent() {
  console.log({ contestActivities });
  var _template = "";
  var empty = "";
  for (var i = 0; i < contestActivities.length; i++) {
    _template += '<div id="divActivity' + i + '" style="margin-bottom: 20px;">';
    _template +=
      "<header> <b> " +
      contestActivities[i].activities +
      ' </b> <span> <button style="margin-left: 15px;" type="button" class="btn btn-primary" onclick="funAddContestTiming(' +
      i +
      ",'" +
      empty +
      "','" +
      empty +
      "','" +
      empty +
      "')\"> Add </button> </header>";
    _template += '<div class="row" style="margin-top: 20px">';
    _template += '<div class="col-md-5"> Time </div>';
    _template += '<div class="col-md-1"> Max count </div>';
    _template += '<div class="col-md-1"> Available </div>';
    _template += "</div>";
    _template +=
      '<div id="divActivityTiming' + i + '" style="margin-top: 20px;"> </div>';
    _template += "</div>";
  }
  $("#divTimingContent").html(_template);
}

function funAddContestTiming(i, value, index, maxCount) {
  var timingIndex = index;
  if (index == "") {
    var timingData = {
      timing: value,
      maxCount,
    };
    timingIndex = activityTimings[contestActivities[i].activities].length;
    activityTimings[contestActivities[i].activities].push(timingData);
  }

  console.log(i, value, timingIndex, { activityTimings });

  var _template = "";

  _template +=
    '<div style="margin-bottom: 20px" class="row" id="divTiming' +
    i +
    "-" +
    timingIndex +
    '"> ';
  _template +=
    '<div class="col-md-5"> <input placeholder="Time" onkeyup="funChangeContestTimingText(' +
    i +
    ", " +
    timingIndex +
    ', this.value, 1)" value="' +
    value +
    '" type="text" class="form-control" /> </div>';
  _template +=
    '<div class="col-md-1"> <input placeholder="Max count" onkeyup="funChangeContestTimingText(' +
    i +
    ", " +
    timingIndex +
    ', this.value, 2)" value="' +
    maxCount +
    '" type="text" class="form-control" /> </div>';
  _template +=
    '<div class="col-md-1"> <input readonly placeholder="Available" value="" type="text" class="form-control" /> </div>';
  _template +=
    '<div class="col-md-1"> <button class="btn btn-danger" onclick="funDeleteContestTiming(' +
    i +
    "," +
    timingIndex +
    ')" type="button"> <i class="fa fa-trash" /> </button> </div>';
  _template += "</div> ";

  $("#divActivityTiming" + i).append(_template);
}

function funChangeContestTimingText(activityIndex, timingIndex, value, type) {
  // console.log({ activityIndex, timingIndex})
  if (type === 1)
    activityTimings[contestActivities[activityIndex].activities][
      timingIndex
    ].timing = value;
  else
    activityTimings[contestActivities[activityIndex].activities][
      timingIndex
    ].maxCount = value;
  funSetValue("txtActivityTiming", JSON.stringify(activityTimings));
}

function funDeleteContestTiming(activityIndex, timingIndex) {
  activityTimings[contestActivities[activityIndex].activities].splice(
    timingIndex,
    1
  );
  $("#divTiming" + activityIndex + "-" + timingIndex).remove();

  funSetValue("txtActivityTiming", JSON.stringify(activityTimings));

  funReRenderContestActivityTimings(activityIndex);
}

function funReRenderContestActivityTimings(activityIndex) {
  $("#divActivityTiming" + activityIndex).html("");
  console.log({
    activityTimings:
      activityTimings[contestActivities[activityIndex].activities],
    length: activityTimings[contestActivities[activityIndex].activities].length,
  });
  for (
    var i = 0;
    i < activityTimings[contestActivities[activityIndex].activities].length;
    i++
  ) {
    // console.log(activityTimings[contestActivities[activityIndex].activities][i].timing);

    var _template = "";

    _template +=
      '<div style="margin-bottom: 20px" class="row" id="divTiming' +
      activityIndex +
      "-" +
      i +
      '"> ';
    _template +=
      '<div class="col-md-5"> <input placeholder="Time" onkeyup="funChangeContestTimingText(' +
      activityIndex +
      ", " +
      i +
      ', this.value, 1)" value="' +
      activityTimings[contestActivities[activityIndex].activities][i].timing +
      '" type="text" class="form-control" /> </div>';
    _template +=
      '<div class="col-md-1"> <input placeholder="Max count" onkeyup="funChangeContestTimingText(' +
      activityIndex +
      ", " +
      i +
      ', this.value, 2)" value="' +
      (activityTimings[contestActivities[activityIndex].activities][i]
        .maxCount || "") +
      '" type="text" class="form-control" /> </div>';
    _template +=
      '<div class="col-md-1"> <input readonly placeholder="Available" value="' +
      (activityTimings[contestActivities[activityIndex].activities][i]
        .available || "") +
      '" type="text" class="form-control" /> </div>';
    _template +=
      '<div class="col-md-1"> <button class="btn btn-danger" onclick="funDeleteContestTiming(' +
      activityIndex +
      "," +
      i +
      ')" type="button"> <i class="fa fa-trash" /> </button> </div>';
    _template += "</div> ";

    $("#divActivityTiming" + activityIndex).append(_template);
  }
}

function funContestTimingChanges(activities, timings = null) {
  console.log(activities);
  $.ajax({
    // Ajax call
    type: "GET",
    dataType: "JSON",
    url: baseURL + adminUrl + "/ajax/get-timings-contest",
    data: "activities=" + activities,
    success: function(response) {
      console.log(response);
      if (response) {
        $("#filter_timings").empty();
        $("#filter_timings").focus;
        $("#filter_timings").append('<option value="">- Timings -</option>');
        $.each(response, function(key, value) {
          $('select[name="filter_timings"]').append(
            "<option " +
              (timings == value.timing ? "selected" : "") +
              ' value="' +
              value.timing +
              '">' +
              value.timing +
              "</option>"
          );
        });
      } else {
        $("#filter_timings").empty();
      }
    },
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    },
  });
}

function funSaveCanteenMenuStatus() {
  var menuStatus = document.getElementById("txtCanteenMenuStatus").value;
  var token = $("input[name='_token']").val();
  console.log(menuStatus);
  $.ajax({
    // Ajax call
    type: "POST",
    url: baseURL + adminUrl + "/ajax/change/canteen-menu-status",
    data: "_token=" + token + "&menu_status=" + menuStatus,
    success: function(response) {
      if (response.status) {
        console.log(response);
        funSuccessMessage("Status has been updated");
      } else {
        funErrorMessage("Error occured !!! Please try after sometime.");
      }
    },
  });
}

$(".auto-service-name").autocomplete({
  lookup: function(query, done) {
    $.ajax({
      // Ajax call
      type: "GET",
      dataType: "JSON",
      url: baseURL + adminUrl + "/ajax/auto-service-name",
      data: "q=" + query,
      success: function(response) {
        var result = {
          suggestions: response,
        };
        done(result);
      },
      error: function() {
        funErrorMessage("Error occured !!! Please try after sometime.");
      },
    });
  },
  onSelect: function(suggestion) {
    console.log(suggestion.data.id);
    funSetValue("filter_product", suggestion.data.id);
    funSetValue("filter_product_name", suggestion.data.name);
  },
  minChars: 1,
});
